import * as React from 'react'

import { listProvidersApiV1ProvidersGet } from '#/shared/api/generated/shipment/theCargoShipment'
import { useInfiniteSearchList } from '#/shared/lib/api/use-infinite-search-list'
import type { PageRequestParams } from '#/shared/lib/api/use-infinite-search-list'
import type { ComboboxOption } from '#/shared/ui/combobox'

const PROVIDERS_QUERY_KEY = ['providers', 'list'] as const

function fetchProvidersPage(params: PageRequestParams, signal?: AbortSignal) {
  return listProvidersApiV1ProvidersGet(
    { q: params.q || null, page: params.page, size: params.size },
    signal,
  )
}

export function useProvidersList(query: string) {
  const [enabled, setEnabled] = React.useState(false)
  const list = useInfiniteSearchList({
    queryKey: PROVIDERS_QUERY_KEY,
    fetcher: fetchProvidersPage,
    query,
    enabled,
  })

  const options: ComboboxOption[] = React.useMemo(
    () =>
      list.items.map((provider) => ({
        value: provider.id,
        label: provider.name,
      })),
    [list.items],
  )

  const onOpenChange = React.useCallback((open: boolean) => {
    if (open) setEnabled(true)
  }, [])

  return {
    options,
    isLoading: list.isLoading,
    isFetchingMore: list.isFetchingMore,
    hasMore: list.hasMore,
    onLoadMore: list.loadMore,
    onOpenChange,
  }
}
